import React from "react";

import { Redirect } from "react-router-dom";

import { FullScreenLoader } from "./UtilityComponents";

interface RedirectWithLoadingProps {
  to: string;
  isLoading: boolean;
}

const RedirectWithLoading: React.FC<RedirectWithLoadingProps> = ({
  to,
  isLoading,
}) => {
  if (isLoading) {
    return <FullScreenLoader />;
  }

  return <Redirect to={to} exact push={false} />;
};

export default RedirectWithLoading;
